export default "__VITE_ASSET__Bsqfcbpb__"